<template>
  <div class="relative overflow-hidden rounded-sm bg-white shadow-[0px_4px_96px_0px_rgba(0,0,0,0.15)]">
    <NuxtLink class="group block font-Spectral text-gray9" :to="destination.to" @click="onCardClick">
      <!-- Figma の比率は Desktop / SP とも 416:234 だが、SP は地図ペインが縦 590px 程度しかなく
           そのまま置くとカードが地図の 55% を覆って他の行き先ラベルが隠れる。SP だけ画像を浅くする。 -->
      <div class="aspect-[2/1] w-full overflow-hidden bg-gray5 md:aspect-[416/234]">
        <OptimizedImage
          v-if="imageUrl"
          alt=""
          class="h-full w-full object-cover transition-transform duration-300 md:group-hover:scale-105"
          loading="lazy"
          :image-url="imageUrl"
          :optimized-image-options="{ width: 840 }"
        />
      </div>
      <div class="flex flex-col gap-2 px-4 py-3 md:py-4">
        <h3 class="text-xl font-medium leading-7 tracking-[0.5px] md:text-2xl md:leading-8 md:group-hover:text-gold3">{{ destination.name }}</h3>
        <!-- 説明文（microCMS summary）がある行き先だけ見出しの下に出す。未入稿なら見出しのみ。
             行数も SP だけ詰める（画像と同じ理由で、地図を覆う面積を抑える）。 -->
        <p v-if="destination.summary" class="line-clamp-3 break-words text-[15px] leading-6 md:line-clamp-4 md:text-[17px]">{{ destination.summary }}</p>
      </div>
    </NuxtLink>
    <!-- Figma の SP フレームには閉じるボタンが無いが、SP ではカードが地図の半分以上を覆うため、
         閉じられないと他の行き先ラベルが隠れたままになる。体験プレビューカードとも揃える。
         カード全体が NuxtLink なので、伝播とデフォルト遷移の両方を止める必要がある。 -->
    <button
      aria-label="Close destination"
      class="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-gray4 shadow-[0px_4px_48px_0px_rgba(0,0,0,0.15)]"
      type="button"
      @click.stop.prevent="onClose"
    >
      <svg aria-hidden="true" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round" /></svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import OptimizedImage from '@/wabunka-src/common/components/stateful/OptimizedImage/OptimizedImage.vue';
import type { SelectableDestination } from '@/wabunka-src/common/features/Featured/core/featuredDestinations/featuredDestinationsMap';

interface Props {
  destination: SelectableDestination;
  /** カードを閉じるコールバック */
  onClose?: () => void;
  /** カードから行き先 LP へ遷移したときのコールバック（GA 計測用。遷移自体は NuxtLink が担う） */
  onCardClick?: () => void;
}

const props = defineProps<Props>();

// 共通の getBackgroundImageUrl は tall 優先だが、このカードは横長（16:9 相当）のため wide を優先する。
const imageUrl = computed<string | undefined>(() => {
  const medias = props.destination.content.backgroundWideMedias?.length ? props.destination.content.backgroundWideMedias : props.destination.content.backgroundTallMedias;
  return medias?.[0]?.url;
});
</script>
